interface IKeyCode {
    key?: string
    code: number
    isShift: boolean
}
interface IKey {
    // spacial
    backspace?: IKeyCode[]
    tab?: IKeyCode[]
    enter?: IKeyCode[]
    delete?: IKeyCode[]

    // general
    numeric?: IKeyCode[]
    dot?: IKeyCode[]

    // operation
    multiply?: IKeyCode[]
    divider?: IKeyCode[]
    plus?: IKeyCode[]
    minus?: IKeyCode[]
    equal?: IKeyCode[]

    // here ! we can add key later
}
// ref https://css-tricks.com/snippets/javascript/javascript-keycodes/
export const KeyCodes: IKey = {
    backspace: [
        {
            code: 8,
            isShift: false,
        },
    ],

    tab: [
        {
            code: 9,
            isShift: false,
        },
    ],

    enter: [
        {
            code: 13,
            isShift: false,
        },
    ],

    delete: [
        {
            code: 46,
            isShift: false,
        },
    ],

    numeric: [
        {
            key: 'numpad0',
            code: 96,
            isShift: false,
        },
        {
            key: 'numpad1',
            code: 97,
            isShift: false,
        },
        {
            key: 'numpad2',
            code: 98,
            isShift: false,
        },
        {
            key: 'numpad3',
            code: 99,
            isShift: false,
        },
        {
            key: 'numpad4',
            code: 100,
            isShift: false,
        },
        {
            key: 'numpad5',
            code: 101,
            isShift: false,
        },
        {
            key: 'numpad6',
            code: 102,
            isShift: false,
        },
        {
            key: 'numpad7',
            code: 103,
            isShift: false,
        },
        {
            key: 'numpad8',
            code: 104,
            isShift: false,
        },
        {
            key: 'numpad9',
            code: 105,
            isShift: false,
        },
        {
            key: '0',
            code: 48,
            isShift: false,
        },
        {
            key: '1',
            code: 49,
            isShift: false,
        },
        {
            key: '2',
            code: 50,
            isShift: false,
        },
        {
            key: '3',
            code: 51,
            isShift: false,
        },
        {
            key: '4',
            code: 52,
            isShift: false,
        },
        {
            key: '5',
            code: 53,
            isShift: false,
        },
        {
            key: '6',
            code: 54,
            isShift: false,
        },
        {
            key: '7',
            code: 55,
            isShift: false,
        },
        {
            key: '8',
            code: 56,
            isShift: false,
        },
        {
            key: '9',
            code: 57,
            isShift: false,
        },
    ],

    dot: [
        {
            code: 110,
            isShift: false,
        },
        {
            code: 190,
            isShift: false,
        },
    ],

    multiply: [
        {
            code: 106,
            isShift: false,
        },
    ],

    minus: [
        {
            code: 109,
            isShift: false,
        },
        {
            code: 189,
            isShift: true,
        },
    ],

    plus: [
        {
            code: 107,
            isShift: false,
        },
        {
            code: 187,
            isShift: true,
        },
    ],

    divider: [
        {
            code: 111,
            isShift: false,
        },
    ],

    equal: [
        {
            code: 187,
            isShift: false,
        },
    ],
}
export interface IMapKeyCodeToID {
    numpad0: string
    numpad00: string
    numpad1: string
    numpad2: string
    numpad3: string
    numpad4: string
    numpad5: string
    numpad6: string
    numpad7: string
    numpad8: string
    numpad9: string
    plus: string
    minus: string
    delete: string
    equal: string
    back: string
    dot: string
    percen5: string
    percen10: string
    percen15: string
    percen20: string
}
export const MapKeyCodeToID: IMapKeyCodeToID = {
    numpad0: 'numpad0',
    numpad00: 'numpad00',
    numpad1: 'numpad1',
    numpad2: 'numpad2',
    numpad3: 'numpad3',
    numpad4: 'numpad4',
    numpad5: 'numpad5',
    numpad6: 'numpad6',
    numpad7: 'numpad7',
    numpad8: 'numpad8',
    numpad9: 'numpad9',
    plus: 'plus',
    minus: 'minus',
    delete: 'delete',
    equal: 'equal',
    back: 'back',
    dot: 'dot',
    percen5: 'numpad5%',
    percen10: 'numpad10%',
    percen15: 'numpad15%',
    percen20: 'numpad20%',
}
